import { Button, Form, Input } from 'antd';
import React from 'react';
import { useCustomers } from './CustomersStore';

function Add() {
    let {addCustomer} = useCustomers()
    
    return (
        <Form layout="vertical" onFinish={addCustomer}>
            <Form.Item label="Familya" name="last_name">
                <Input />
            </Form.Item>
            <Form.Item label="Ismi" name="first_name">
                <Input />
            </Form.Item>
            <Form.Item label="Telefon" name="mobile">
                <Input />
            </Form.Item>
            <Form.Item label="Qarzi" name="balance">
                <Input />
            </Form.Item>
            <Form.Item label="Manzil" name="address">
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;